import { MutationTree } from "vuex";
import { kidState } from "./types";

export const mutations: MutationTree<kidState> = {};
